export function queryParam(object) {
  return new URLSearchParams(object).toString();
}
